import React from "react";
import "./Home.scss";
import { Dashboard } from "./Components";

/**
 * @description - Global application home page component
 * @author Tharanga Niroshana <tharangan@unicorn-solutions.com>
 * @since 12/01/2025
 */
export default () => {
  return (
    <>
      <div className="home-wrap">
        <Dashboard />
      </div>
      <div className="home-footer">
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <svg viewBox="0 0 122 25" width="100" height="20">
              <path
                fill="#0b3b49"
                d="M18.86,25c-12.04-1.05-10.63-20.04,2.21-18.11,3.95.59,6.57,3.92,6.99,7.77.05.51.14,1.57.09,2.04-.01.11,0,.19-.11.25h-14.73c.53,3.49,3.15,5.86,6.76,5.63,2.08-.13,3.62-1.26,4.68-3h2.81c-1.05,3.04-3.93,5.3-7.19,5.34l-.12.07h-1.39ZM25.37,14.47c-.37-2.41-2.04-4.68-4.52-5.17-1.27-.25-2.64-.2-3.85.27-1.93.74-3.4,2.87-3.62,4.9h11.99Z"
              />
              <path
                fill="#0b3b49"
                d="M104.53,25c-12.03-1.09-10.59-20.03,2.21-18.11,3.89.58,6.53,3.82,6.99,7.63.07.6.15,1.6.09,2.19-.01.11,0,.19-.11.25h-14.73c.41,2.56,2.01,4.81,4.62,5.43,2.82.67,5.37-.29,6.82-2.8h2.81c-.75,2.3-2.74,4.29-5.06,4.99-.66.2-1.57.37-2.25.42h-1.39ZM111.04,14.47c-.27-2.05-1.65-4.15-3.62-4.9-1.44-.55-3.32-.56-4.75,0-1.97.77-3.32,2.84-3.62,4.9h11.99Z"
              />
              <path
                fill="#0b3b49"
                d="M56.73,25h-1.39c-10.84-.78-10.56-17.58-.19-18.21,12.51-.75,12.72,17.43,1.58,18.21ZM55.76,9.16c-8.06.29-7.77,13.97.78,13.43,7.67-.49,7.57-13.72-.78-13.43Z"
              />
              <path
                fill="#0b3b49"
                d="M37.06,25c-.19-.15-.46-.05-.69-.07-3.21-.39-5.99-2.35-6.25-5.77h2.78c.15,1.77,1.51,3.05,3.2,3.41,2.1.45,6.46.13,6.23-2.87-.11-1.44-1.7-2.02-2.9-2.37-3.65-1.05-10.03-1.2-8.71-6.82.81-3.45,5.03-3.93,7.98-3.71s5.36,2,5.74,4.97h-2.7c-.13-1.13-.99-2.09-2.05-2.45-1.39-.47-4.16-.43-5.43.34s-1.41,2.66-.15,3.55c2.78,1.96,10.41,1.06,10.84,5.75.38,4.12-2.72,5.79-6.36,6.03h-1.54Z"
              />
              <path
                fill="#0b3b49"
                d="M121.42,0v3.87l-.44.07V.73c-.17-.05-.12.04-.17.09-.45.52-.84,1.12-1.26,1.66-.29,0-1.21-1.58-1.57-1.76v3.22h-.44V0l.58.04,1.35,1.79c.14,0,1.09-1.6,1.31-1.76.05-.03.09-.07.15-.07h.47Z"
              />
              <path
                fill="#1db04c"
                d="M82.89,19.8L95.76.55c1.57-1.47,4.06.27,3.2,2.25l-14.43,21.53c-.58.69-1.83.82-2.55.3l-7.97-8.04c-1.48-1.92.91-4.38,2.85-2.78.94.77,2.08,2.06,2.96,2.96.95.97,1.82,2.03,2.81,2.97l.25.06Z"
              />
              <path
                fill="#0b3b49"
                d="M9.28,6.8v2.63h-1.13c-2.92,0-5.53,4.07-5.52,6.76v8.52s-2.63,0-2.63,0V7.02h2.63v4.24l.96-1.78c.84-1.21,2.99-2.68,4.48-2.68h1.21Z"
              />
              <rect fill="#0b3b49" x="68.27" width="2.63" height="24.71" />
              <polygon
                fill="#0b3b49"
                points="116.96 0 116.96 .44 115.64 .44 115.64 3.84 115.2 3.95 115.2 .44 113.82 .44 113.82 0 116.96 0"
              />
            </svg>
          </div>
          <div>
            <span className="font-sm">Fair Technology AS</span>
          </div>
        </div>
        <div className="font-sm text-muted d-flex justify-content-between align-items-center foot-link">
          <div>
            <a href="https://www.fair.no/personvern" target="_blank">
              Personvern | Fair Norge
            </a>
          </div>
          <div>
            <svg viewBox="0 0 53 20" width="53" height="20">
              <path
                fill="#1db04c"
                d="M.17,8.74C.45,1.94,7.85-2.19,13.81,1.22s5.95,12.79-.49,15.97c-.13.06-.95.44-1.02.4l-.38-1.16c3.52-1.26,5.64-4.84,5.1-8.54C16.34,3.15,11.6.16,6.98,1.52,3.17,2.65.84,6.43,1.5,10.36c.46,2.75,2.44,5.15,5.07,6.07l-.38,1.16s-.26-.07-.32-.09C2.57,16.21.33,12.96.17,9.44c-.01-.22,0-.48,0-.7ZM13.27,10.16l-.06-.05H5.18s-.48,1.4-.48,1.4h9l-.44-1.36ZM4.73,6.44l.44,1.36.06.05h8.01s.46-1.4.46-1.4H4.73ZM8.63,15.38v4.62h1.24v-4.62h-1.24Z"
              />
              <path
                fill="#000000"
                d="M26.52,7.23c.05-1.23-.21-2.55.52-3.63.96-1.42,2.84-1.37,4.37-1.34l-.33,1.43c-.67.02-1.39-.07-2.03.18-1.38.54-.96,2.19-1.03,3.36h2.16l-.32,1.3h-1.84v7.21h-1.51v-7.21h-1.7v-1.3h1.7ZM40.71,15.73V6.09h-1.22l-.27,1.05c-.5-.65-1.15-1.08-1.95-1.28-2.8-.71-5.5.58-6.24,3.44-.94,3.67,1.65,7.22,5.59,6.51,1.22-.22,1.73-.7,2.51-1.57.02-.03.02-.06.08-.05l.27,1.54h1.22ZM39.27,11.21c-.15,2.37-2.19,3.89-4.51,3.19-3.47-1.05-3.08-7.02.67-7.35,2.59-.23,4,1.73,3.84,4.16ZM47.71,6.19l-.04-.04h-1.47l.03,9.67h1.47s.04-.05.04-.09c.04-.38,0-.98,0-1.38-.02-2.11-.42-4.68,1.3-6.27.73-.68,1.68-.94,2.67-.88l.36-1.47c-.43-.04-.85-.06-1.28-.01-1.15.15-2.21.89-2.78,1.9l-.29.61v-2.04ZM42.71,6.09v9.64h1.49V6.09h-1.49ZM44.11,2.3l-.04-.04h-1.36l-.35,1.43h1.76v-1.39Z"
              />
            </svg>
          </div>
        </div>
      </div>
    </>
  );
};
